module.exports = __webpack_public_path__ + "assets/img/person-bg.e7f7bacf.jpg";